<template>
  <div class="ov-page">
    <div class="ov-header">
      <div class="ov-note ov-note--info ov-header__note">
        <v-icon small>mdi-information-outline</v-icon>
        <span>{{ $t('adhesion.manageRequests') }}</span>
      </div>
      <div class="ov-header__actions">
        <button type="button" class="ov-btn ov-btn--primary" @click="$router.push('/CreerAdhesionAdmin')">
          <v-icon small>mdi-plus</v-icon>
          {{ $t('menu.adhesion.create') }}
        </button>
      </div>
    </div>

    <div class="ov-stack">
      <!-- ===== DEMANDES EN ATTENTE ===== -->
      <div class="ov-card">
        <div class="ov-card__head">
          <div class="ov-card__title">
            {{ $t('adhesion.pendingRequests') }}
            <span class="ov-count">{{ demandeAdhesionList.length }}</span>
          </div>
          <div class="ov-search">
            <v-icon small>mdi-magnify</v-icon>
            <input v-model="searchPending" type="text" class="ov-input" :placeholder="$t('adhesion.search')" />
          </div>
        </div>

        <v-data-table
          :headers="headers"
          :items="demandeAdhesionList"
          :search="searchPending"
          :loading="loading"
          loader-height="2"
          class="ov-table"
          :loading-text="$t('adhesion.loading')"
          :no-data-text="$t('adhesion.noData')"
        >
          <template v-slot:[`item.isValidate`]="{ item }">
            <span v-if="item.isValidate" class="ov-badge ov-badge--success">Validé</span>
            <span v-else class="ov-badge ov-badge--danger">En attente</span>
          </template>

          <template v-slot:[`item.isActif`]="{ item }">
            <span v-if="item.isActif" class="ov-badge ov-badge--success">Actif</span>
            <span v-else class="ov-badge ov-badge--neutral">Inactif</span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="ov-row-actions">
              <button type="button" class="ov-icon-btn" :title="$t('adhesion.details')" @click="verifierInfosDemandeAdhesion(item)">
                <v-icon small>mdi-eye-outline</v-icon>
              </button>
            </div>
          </template>
        </v-data-table>
      </div>

      <!-- ===== ADHÉSIONS VALIDÉES ===== -->
      <div class="ov-card">
        <div class="ov-card__head">
          <div class="ov-card__title">
            {{ $t('adhesion.validatedMemberships') }}
            <span class="ov-count">{{ demandeAdhesionValidesList.length }}</span>
          </div>
          <div class="ov-search">
            <v-icon small>mdi-magnify</v-icon>
            <input v-model="searchValidated" type="text" class="ov-input" :placeholder="$t('adhesion.search')" />
          </div>
        </div>

        <v-data-table
          :headers="headers"
          :items="demandeAdhesionValidesList"
          :search="searchValidated"
          :loading="loading"
          loader-height="2"
          class="ov-table"
          :loading-text="$t('adhesion.loading')"
          :no-data-text="$t('adhesion.noData')"
        >
          <template v-slot:[`item.isValidate`]="{ item }">
            <span v-if="item.isValidate" class="ov-badge ov-badge--success">Validé</span>
            <span v-else class="ov-badge ov-badge--danger">En attente</span>
          </template>

          <template v-slot:[`item.isActif`]="{ item }">
            <span v-if="item.isActif" class="ov-badge ov-badge--success">Actif</span>
            <span v-else class="ov-badge ov-badge--neutral">Inactif</span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="ov-row-actions">
              <button type="button" class="ov-icon-btn" :title="$t('adhesion.details')" @click="verifierInfosDemandeAdhesionValide(item)">
                <v-icon small>mdi-eye-outline</v-icon>
              </button>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>

    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import {
  API_OBTENIR_LISTE_DE_TOUTES_LES_DEMANDES_ADHESIONS,
  API_OBTENIR_LISTE_DES_DEMANDES_ADHESIONS_VALIDEES,
  HEADERS,
} from "@/components/globalConfig/globalConstConfig";
import { showErrorMessage } from "../messages/messageProcess";

export default {
  name: "AdhesionList",
  data() {
    return {
      errorMsg: null,
      successMsg: null,
      warningMsg: null,

      demandeAdhesionList: [],
      demandeAdhesionValidesList: [],
      demandeAdhesionNonValides: 0,
      demandeAdhesionValides: 0,

      searchPending: "",
      searchValidated: "",
      headers: [
        { text: this.$t('adhesion.designation'), value: "designation" },
        { text: this.$t('adhesion.company'), value: "raisonSociale" },
        { text: this.$t('adhesion.email'), value: "email" },
        { text: this.$t('adhesion.validity'), value: "isValidate" },
        { text: this.$t('adhesion.active').toLowerCase(), value: "isActif" },
        { text: this.$t('adhesion.actions'), value: "actions", sortable: false },
      ],
      loading: true,

      options: {
        index: 0,
        size: 8,
      },
    };
  },

  methods: {
    verifierInfosDemandeAdhesion(demandeAdhesion) {
      this.$router.push({
        name: "InfosAdhesion",
        params: { raisonSociale: demandeAdhesion.raisonSociale },
      });
    },

    verifierInfosDemandeAdhesionValide(demandeAdhesion) {
      this.$router.push({
        name: "InfosAdhesionValide",
        params: { raisonSociale: demandeAdhesion.raisonSociale },
      });
    },

    //OBTENIR LA LISTE DE TOUTES LES DEMANDE D'ADHESIONS EFFECTUÉS
    async getAllAdhesionList() {
      this.loading = true;
      axios
        .post(
          API_OBTENIR_LISTE_DE_TOUTES_LES_DEMANDES_ADHESIONS,
          this.options,
          { headers: HEADERS(this.$store.state.userAuthentified.token) }
        )
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code != 800) {
              this.demandeAdhesionList = [];
            } else {
              this.demandeAdhesionList = response.data.items;
            }
          } else {
            this.errorMsg = this.$t('adhesion.error');
            showErrorMessage();
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // OBTENIR LA LISTE DES DEMANDES D'ADHESIONS VALIDÉES
    async getAllDemandeAdhesionValidees() {
      this.loading = true;
      axios
        .post(API_OBTENIR_LISTE_DES_DEMANDES_ADHESIONS_VALIDEES, this.options, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code != 800) {
              this.errorMsg = response.data.status.message;
              showErrorMessage();
            } else {
              this.demandeAdhesionValidesList = response.data.items;
            }
          } else {
            this.errorMsg = this.$t('adhesion.error');
            showErrorMessage();
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  mounted() {
    this.getAllAdhesionList();
    this.getAllDemandeAdhesionValidees();
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/admin/ui";

.ov-table ::v-deep tbody td:last-child,
.ov-table ::v-deep thead th:last-child {
  width: 80px;
}
</style>
